import React from "react";
import { type Columns } from "../../component/Edit";
import useLocale from "../../util/i18n";
import { useCrumbs } from "../../component/breadcrumbs";
import Config from "./Config";
import { Helmet } from "react-helmet-async";

export default function ConfigStock() {
    const {0: __} = useLocale();
    const {0: setCrumbs} = useCrumbs();
    let columns = React.useMemo<Columns>(() => ({
        [__('Stock')]: [
            {
                name: 'stock/box',
                label: __('Bin Location'),
                required: true,
                comment: __('Comma Separated.')
            }
        ]
    }), [__]);
    React.useEffect(() => {
        setCrumbs(['Stock Config']);
    }, []);
    return (
        <>
            <Helmet>
                <title>{__('Bin Location')}</title>
            </Helmet>
            <Config columns={columns} />
        </>
    );
}